import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ShareViaURLOptions, ShareViaUrlService } from './share-via-url.service';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'cv-share-via-url',
    templateUrl: './share-via-url.component.html',
    styleUrls: ['./share-via-url.component.scss']
})
export class ShareViaUrlComponent implements OnInit {

    @ViewChild('shareURLLink') shareURLLink: ElementRef;
    @ViewChild('refreshLinkPopover') refreshLinkPopover: PopoverDirective;

    enabled = false;
    shareURL = '';
    linkCopied = false;

    private modalData: ShareViaURLOptions;

    constructor(
        private clipboard: Clipboard,
        private activeModal: NgbActiveModal,
        private service: ShareViaUrlService,
    ) {
        this.modalData = this.service._getModalData();
    }

    ngOnInit(): void {
        if (this.modalData.dashboard.SharedKey && this.modalData.dashboard.IsSharedURL) {
            this.shareURL = `${window.location.origin}/Dashboard/SharedDashboard.aspx?id=${this.modalData.dashboard.SharedKey}`;
            this.enabled = this.modalData.dashboard.IsSharedURL;
        }
    }

    onCancelClicked() {
        this.activeModal.close();
    }

    async onToggleClicked() {
        if (this.enabled) {
            if (this.modalData.dashboard.SharedKey) {
                this.shareURL = `${window.location.origin}/Dashboard/SharedDashboard.aspx?id=${this.modalData.dashboard.SharedKey}`;
            } else {
                this.modalData.dashboard.SharedKey = await this.service.generateSharedKey();
                this.shareURL = `${window.location.origin}/Dashboard/SharedDashboard.aspx?id=${this.modalData.dashboard.SharedKey}`;
            }
        } else {
            this.shareURL = '';
        }
    }

    onCopyClicked() {
        this.clipboard.copy(this.shareURL);
        this.linkCopied = true;
    }

    onRefreshLinkClicked() {
        this.refreshLinkPopover.show();
    }

    refreshLinkCancel() {
        this.refreshLinkPopover.hide();
    }

    async refreshLinkConfirm() {
        this.modalData.dashboard.SharedKey = await this.service.generateSharedKey();
        this.shareURL = `${window.location.origin}/Dashboard/SharedDashboard.aspx?id=${this.modalData.dashboard.SharedKey}`;
        this.refreshLinkPopover.hide();
        this.linkCopied = false;
    }

    onSaveClicked() {
        this.modalData.dashboard.IsSharedURL = this.enabled;
        if (this.modalData.dashboard.SharedKey !== null)
            this.service.modifyDashboardSharedViaURL(this.modalData.dashboard);
        this.activeModal.close();
    }
}
